import React from "react";
import "../styles/RouteLoadingFallback.css";

const RouteLoadingFallback = () => (
  <div
    className="route-loading-fallback"
    role="status"
    aria-live="polite"
    aria-label="Загрузка страницы"
  >
    <span
      className="route-loading-fallback__spinner"
      aria-hidden="true"
    />
    <span className="route-loading-fallback__text">
      Загрузка…
    </span>
  </div>
);

export default RouteLoadingFallback;
